module.exports = __webpack_public_path__ + "static/media/01_hero_tablet.73d2e48d.jpg";